import { render, staticRenderFns } from "./ConsumablesLogs.vue?vue&type=template&id=4f122d08&scoped=true&"
import script from "./ConsumablesLogs.vue?vue&type=script&lang=js&"
export * from "./ConsumablesLogs.vue?vue&type=script&lang=js&"
import style0 from "./ConsumablesLogs.vue?vue&type=style&index=0&id=4f122d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f122d08",
  null
  
)

export default component.exports